import { en } from "vuetify/lib/locale";

export default {
  $vuetify: { ...en },
  ...en,
  legal_top: {
    title: "Terms and Conditions",
    text: "Discover News, Tips, and Insights for Future Residents of Our Unique Sustainable Living Project",
  },
  platform: {
    btn_top:{
      btn_cameras: "Web Cameras",
      btn_btob: "B&B Management",
      btn_legal: "Legal updates",
    },
    title: "Member platform",
    welcome: "Welcome",
  },
  platform_auth: {
    title: "Borgoolistico Member platform",
    suptitle: "Please log in with your personal ID and password to get access to Borgoolistico cameras and information",
    btn_login: "Log in"
  },
  contact: {
    links: {
      call: "Call us",
      insta: "Find us in Instagram",
      whatsapp: "Find us in WhatsApp",
    }
  },
};
